(function () {
    'use strict';

    angular.module('ib-MmB-refund-doubts-and-rights-module', []);
    
})();